<template>
  <div class="add-download">
    <div class="form-content">
      <el-form>
        <el-row>
          <el-col :span="12">
            <el-form-item label="语言" required>
              <el-select v-model="currentData.language_code" placeholder="请选择语言">
                <el-option v-for="item in languageList" :key="item.code" :label="item.name" :value="item.code" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="首页展示">
              <el-switch
                v-model="currentData.is_home"
                :active-value="1"
                :inactive-value="0"
                active-color="#409EFF"
                inactive-color="#dcdfe6"
              />
              <span style="margin-left: 10px; font-size: 12px; color: #909399;">
                （最多展示 3 条）
              </span>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 标题 -->
        <el-form-item label="标题" required>
          <el-input v-model="currentData.title" placeholder="请输入下载资料标题" />
        </el-form-item>

        <!-- 副标题 -->
        <el-form-item label="副标题">
          <el-input v-model="currentData.sub_title" placeholder="请输入副标题（选填）" />
        </el-form-item>

        <!-- 上传文件 -->
        <el-form-item label="上传文件" required>
          <el-upload
            v-if="!currentData.link"
            class="file-uploader"
            :action="uploadAction"
            :data="uploadPostData"
            :on-success="handleFileSuccess"
            :on-error="handleFileError"
            :before-upload="beforeFileUpload"
            :show-file-list="false"
            accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.zip,.rar,.7z,.txt,.csv"
          >
            <div class="upload-trigger">
              <i class="el-icon-upload2" style="font-size: 36px; color: #409EFF;"></i>
              <div class="upload-text">点击上传文件</div>
              <div class="upload-tip">支持 PDF、Word、Excel、PPT、压缩包等格式</div>
            </div>
          </el-upload>
          <div v-else class="file-info">
            <div class="file-name">
              <i class="el-icon-document"></i>
              <span>{{ getFileName(currentData.link) }}</span>
            </div>
            <el-button type="text" icon="el-icon-delete" style="color: #F56C6C;" @click="removeFile">删除</el-button>
          </div>
        </el-form-item>

        <!-- 内容 -->
        <el-form-item label="内容">
          <div class="rich-text-editor-container">
            <rich-text-editor
              v-model="currentData.content"
              :path="'download'"
              :placeholder="placeholders[currentData.language_code] || '请输入内容'"
              @change="handleContentChange"
            />
          </div>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表单操作 -->
    <div class="form-actions">
      <el-button @click="$emit('cancel')">取消</el-button>
      <el-button type="primary" @click="handleSubmit">保存</el-button>
    </div>
  </div>
</template>

<script>
import { getLanguage, getQiniuToken } from '@/api/public'
import RichTextEditor from '@/components/tool/RichTextEditor'
import { addDownload, updateDownload } from '@/api/website'

export default {
  name: 'AddDownload',
  components: {
    RichTextEditor
  },
  props: {
    download: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      languageList: [],
      currentData: {
        language_code: 'zh',
        title: '',
        sub_title: '',
        link: '',
        content: '',
        is_home: 0
      },
      placeholders: {
        zh: '请输入下载资料内容',
        en: 'Please enter download content',
        ko: '다운로드 콘텐츠를 입력하세요'
      },
      uploadAction: 'https://up-z0.qiniup.com',
      uploadPostData: {
        token: '',
        key: ''
      },
      uploadDomain: 'https://cdn.puditech.com/'
    }
  },
  watch: {
    download: {
      handler(newDownload) {
        if (newDownload) {
          this.resetForm()
          this.currentData = {
            id: newDownload.id,
            language_code: newDownload.language_code || 'zh',
            title: newDownload.title || '',
            sub_title: newDownload.sub_title || '',
            link: newDownload.link || '',
            content: newDownload.content || '',
            is_home: newDownload.is_home || 0
          }
        } else {
          this.resetForm()
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.getLanguageList()
    this.getUploadToken()
  },
  methods: {
    async getLanguageList() {
      try {
        const res = await getLanguage()
        this.languageList = res.data || []
      } catch (error) {
        console.error('获取语言列表失败:', error)
      }
    },
    async getUploadToken() {
      try {
        const res = await getQiniuToken()
        this.uploadPostData.token = res.data
      } catch (error) {
        console.error('获取上传 Token 失败:', error)
      }
    },
    createNonceStr() {
      var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
      var res = ''
      for (var i = 0; i < 16; i++) {
        res += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      return res
    },
    getSuffix(filename) {
      var index = filename.lastIndexOf('.')
      return filename.substr(index + 1)
    },
    beforeFileUpload(file) {
      this.uploadPostData.key = 'download/' + this.createNonceStr() + '.' + this.getSuffix(file.name)
      return true
    },
    handleFileSuccess(res) {
      if (res.key) {
        this.currentData.link = this.uploadDomain + res.key
        this.$message.success('文件上传成功')
      }
    },
    handleFileError() {
      this.$message.error('文件上传失败，请重试')
    },
    removeFile() {
      this.currentData.link = ''
    },
    getFileName(url) {
      if (!url) return ''
      var parts = url.split('/')
      return decodeURIComponent(parts[parts.length - 1]) || '已上传文件'
    },
    resetForm() {
      this.currentData = {
        language_code: 'zh',
        title: '',
        sub_title: '',
        link: '',
        content: '',
        is_home: 0
      }
    },
    handleContentChange(content) {
      this.currentData.content = content
    },
    handleSubmit() {
      // 验证
      if (!this.currentData.language_code) {
        this.$message.error('请选择语言')
        return
      }
      if (!this.currentData.title) {
        this.$message.error('请输入标题')
        return
      }
      if (!this.currentData.link) {
        this.$message.error('请上传文件')
        return
      }

      // 提交
      const submitData = { ...this.currentData }
      const isEdit = submitData.id

      const apiCall = isEdit
        ? updateDownload(submitData.id, submitData)
        : addDownload(submitData)

      apiCall.then(res => {
        if (res.code === 200) {
          this.$emit('save', true)
        } else {
          this.$message.error(res.msg || '保存失败')
        }
      }).catch(() => {
        this.$message.error('保存失败')
      })
    }
  }
}
</script>

<style scoped lang="scss">
.add-download {
  box-sizing: border-box;
  padding: 0 20px;
}

.form-content {
  box-sizing: border-box;
  margin-bottom: 30px;
}

.rich-text-editor-container {
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  background-color: #f9f9f9;
  padding: 10px;
  min-height: 300px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #f0f2f5;
}

/* 响应式 */
@media (max-width: 768px) {
  .add-download {
    padding: 10px 0;
  }

  .form-content {
    margin-bottom: 20px;
  }

  .rich-text-editor-container {
    min-height: 200px;
  }

  .form-actions {
    flex-direction: column;
  }

  .form-actions .el-button {
    width: 100%;
  }

  .quill-editor {
    height: 150px;
  }

  .ql-toolbar.ql-snow {
    flex-wrap: wrap;
  }

  .ql-toolbar.ql-snow .ql-formats {
    margin-right: 10px;
    margin-bottom: 5px;
  }
}

.file-uploader {
  width: 100%;
}

.upload-trigger {
  width: 360px;
  height: 120px;
  border: 2px dashed #d9d9d9;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 0.3s;
  box-sizing: border-box;
  padding: 10px;
}

.upload-trigger:hover {
  border-color: #409EFF;
}

.upload-text {
  margin-top: 8px;
  font-size: 14px;
  color: #606266;
}

.upload-tip {
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
}

.file-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  background: #f5f7fa;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  max-width: 400px;
}

.file-name {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #606266;
  overflow: hidden;
}

.file-name span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-name i {
  color: #409EFF;
  font-size: 18px;
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .upload-trigger {
    width: 100%;
    height: 100px;
  }

  .file-info {
    max-width: 100%;
  }
}
</style>
